import {
  GET_FUEL,
  GET_FUEL_ERROR,
  GET_FUEL_SUCCESS,
  ADD_FUEL,
  ADD_FUEL_ERROR,
  ADD_FUEL_SUCCESS,
} from './TankerTruck.actions';

const userState = {
  eventosPorCamion: {}, // { SZBX30: [...], SZBK98: [...] }
  remanentePorCamion: {}, // { SZBX30: 12000, SZBK98: 3000 }
  loading_fueles: false,
  error_fueles: undefined,
  loading_add_fuel: false,
  error_add_fuel: undefined,
};

const tankerReducer = (state = userState, { payload, type }) => {
  switch (type) {
    case GET_FUEL:
      return { ...state, loading_fueles: true, error_fueles: undefined };

    case GET_FUEL_ERROR:
      return { ...state, loading_fueles: false, error_fueles: payload.error };

    case GET_FUEL_SUCCESS:
      return {
        ...state,
        loading_fueles: false,
        error_fueles: undefined,
        eventosPorCamion: {
          ...state.eventosPorCamion,
          [payload.patent]: payload.eventos,
        },
        remanentePorCamion: {
          ...state.remanentePorCamion,
          [payload.patent]: payload.combustibleRemanente,
        },
      };

    case ADD_FUEL:
      return { ...state, loading_add_fuel: true, error_add_fuel: undefined };

    case ADD_FUEL_ERROR:
      return {
        ...state,
        loading_add_fuel: false,
        error_add_fuel: payload.error,
      };

    case ADD_FUEL_SUCCESS:
      return {
        ...state,
        loading_add_fuel: false,
        error_add_fuel: undefined,
        remanentePorCamion: {
          ...state.remanentePorCamion,
          [payload.patent]: payload.combustibleRemanente,
        },
      };

    default:
      return state;
  }
};

export default tankerReducer;
